import { render, staticRenderFns } from "./ListZonas.vue?vue&type=template&id=d0cca838&scoped=true&"
import script from "./ListZonas.vue?vue&type=script&lang=js&"
export * from "./ListZonas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cca838",
  null
  
)

export default component.exports